export default __webpack_public_path__ + "static/media/cc-visa.5f26286c.svg";